<template>
    <div>
        <el-card class="box-card">
            <ve-line :data="lineData"></ve-line>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      lineData: {
        columns: ['DATE', 'OD', 'OS', 'OU'],
        rows: []
      }
    }
  },
  mounted () {
    const TempUuid = this.$route.query.TempUuid;
    this.apiAnisoFocusListVisionTrend(TempUuid);
  },
  methods: {
    apiAnisoFocusListVisionTrend: function (TempUuid) {
      var that = this
      var data = {
        TempUuid: TempUuid
      }
      axios.post(Vue.prototype.global.Url_AnisoFocusListVisionTrend, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.lineData.rows = []
            response.data.List.filter((item1, i1) => {
              that.lineData.rows.push({ DATE: item1.CreateTime, OD: item1.Od, OS: item1.Os, OU: item1.Ou })
            })
          } else {
            Vue.prototype.FunAlertMsg(response.data.Errormsg)
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
